<template>
  <div class="root">
    <template v-if="discount&&Number(discount.discount)!==10">
      <b class="left">{{discount.discount}}折报名中</b>
    </template>
    <template v-else-if="discount&&Number(discount.discount)===10">
      <div class="wrapper">
        <h1 class="">报名倒计时{{discount.remainDays}}天</h1>
        <!-- <h2 class="">团购享更多优惠</h2> -->
      </div>
    </template>
    <template v-else>
      <div>
        <h1 v-if="data.title || data.subtitle" v-html="data.title || data.subtitle"></h1>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
    }
  },
  props: ['data', 'price'],
  computed: {
    discount () {
      if (!this.data.showDiscount) return false
      for (let i = 0; i < this.price.discount.length; i++) {
        let d = this.price.discount[i]
        let cur = moment()
        let end = moment(new Date(d.end))
        if (!cur.isAfter(end)) {
          let remainDays = moment(end).diff(cur, 'days') + 1
          let discountPrice = (this.price.price - d.price) / 100
          let discount = d.discount
          return { remainDays, discountPrice, discount }
        }
      }
      return false
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
  @import "../../../assets/style/variable.sass"

  .root
    padding: 6px 11px
    display: flex
    justify-content: center
    align-items: center
    background-color: #0078d2
    color: #fff
    font-size: 14px
    border-radius: 4px
</style>
